import { AsyncReturnType } from "type-fest";

import { CrmService } from "@/services/crm-service";
import { UseMutationSimpleOptions, useMutation } from "@/services/hooks";

type Variables = Parameters<typeof CrmService.linkTag>[0];
type Data = AsyncReturnType<typeof CrmService.linkTag>;
type Error = unknown;

export const useLinkTag = <TContext = unknown>(
  options?: UseMutationSimpleOptions<Data, Error, Variables, TContext>
) => {
  const result = useMutation<Data, Error, Variables, TContext>(
    CrmService.linkTag,
    options
  );

  return result;
};
